import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";

export interface Crumb {
  name: string;
  /** Omit href on the current page (last crumb). */
  href?: string;
}

interface BreadcrumbsProps {
  items: Crumb[];
  className?: string;
}

/**
 * Visible breadcrumb trail. Pair with a schema.org BreadcrumbList in the page's
 * JSON-LD — Google requires the markup to match what's rendered on the page.
 */
export const Breadcrumbs = ({ items, className }: BreadcrumbsProps) => (
  <nav aria-label="Breadcrumb" className={cn("w-full", className)}>
    <ol className="flex flex-wrap items-center gap-1.5 text-[10px] uppercase tracking-[0.22em] text-silver">
      {items.map((item, i) => {
        const isLast = i === items.length - 1;
        return (
          <li key={item.name} className="flex items-center gap-1.5">
            {item.href && !isLast ? (
              <Link to={item.href} className="hover:text-white transition-colors">
                {item.name}
              </Link>
            ) : (
              <span aria-current="page" className="text-white/80">
                {item.name}
              </span>
            )}
            {!isLast && <ChevronRight className="h-3 w-3 text-gold/60" aria-hidden="true" />}
          </li>
        );
      })}
    </ol>
  </nav>
);
